const WHATSAPP_URL = 'https://wa.me/5511986765185?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20um%20or%C3%A7amento%20para%20fechamento%20de%20sacada.';

export default function Footer() {
  return (
    <footer className="bg-stone-50 border-t border-stone-200">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/b82e091d2ee2b446e9b53ab9857e20be/1bea56054998f72dc157944f3d260472.png"
            alt="Vidros Thelux"
            className="h-7 object-contain"
          />
          <span className="text-stone-300 text-lg font-light">|</span>
          <p className="text-stone-400 text-xs">
            Envidraçamento de Sacada — São Paulo
          </p>
        </div>

        <div className="flex items-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-stone-500 hover:text-green-600 transition-colors text-xs whitespace-nowrap cursor-pointer"
          >
            (11) 98676-5185
          </a>
          <p className="text-stone-400 text-xs">
            © {new Date().getFullYear()} Vidros Thelux
          </p>
        </div>
      </div>
    </footer>
  );
}